// components/InAppCamera.js
import React, { useEffect, useRef, useState } from "react";

export default function InAppCamera({ onCancel, onCapture }) {
  const videoRef = useRef(null);
  const [stream, setStream] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const st = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: { ideal: "environment" } },
          audio: false
        });
        setStream(st);
        if (videoRef.current) {
          videoRef.current.srcObject = st;
          await videoRef.current.play();
        }
      } catch (e) {
        setError(e?.message || "Camera not available");
      }
    })();
    return () => stream?.getTracks?.().forEach(t => t.stop());
  }, []);

  const takePhoto = () => {
    const video = videoRef.current;
    if (!video) return;
    const canvas = document.createElement("canvas");
    // keep size moderate for memory (Xiaomi is sensitive)
    const w = Math.min(1280, video.videoWidth || 1280);
    const h = Math.round((w / (video.videoWidth || 1280)) * (video.videoHeight || 720));
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, w, h);
    canvas.toBlob((blob) => {
      if (blob) {
        onCapture(new File([blob], "photo.jpg", { type: "image/jpeg" }));
      }
    }, "image/jpeg", 0.8);
  };

  if (error) {
    return (
      <div className="p-3">
        <p>Couldn’t open camera: {error}</p>
        <button onClick={onCancel}>Close</button>
      </div>
    );
  }

  return (
    <div className="p-3" style={{ position: "fixed", inset: 0, background: "#000", zIndex: 9999 }}>
      <video ref={videoRef} playsInline style={{ width: "100%", height: "auto" }} />
      <div style={{ position: "absolute", bottom: 20, left: 0, right: 0, display: "flex", gap: 12, justifyContent: "center" }}>
        <button onClick={takePhoto}>Capture</button>
        <button onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
}
